import he from '../JsonLang/he.json'
export const lang = { ...he }